const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
const CONTAINER_ID = 'cf-turnstile-container'
const EXECUTE_TIMEOUT_MS = 5000
const READY_TIMEOUT_MS = 8000

export const CAPTCHA_WIDGET_ID = 'rugbyZone'

function siteKey() {
  return process.env.VUE_APP_TURNSTILE_SITE_KEY
}

let initialized = false
let widgetId = null
let pending = null
let markReady = null
const ready = new Promise((resolve) => { markReady = resolve })

function settleReady() {
  if (markReady) {
    markReady()
    markReady = null
  }
}

function resolvePending(token) {
  const resolve = pending
  pending = null
  if (resolve) resolve(token)
}

function rearmWidget() {
  try {
    if (widgetId && window.turnstile) window.turnstile.reset(widgetId)
  } catch (e) {
    widgetId = widgetId || null
  }
}

function renderWidget() {
  try {
    widgetId = window.turnstile ? window.turnstile.render('#' + CONTAINER_ID, {
      sitekey: siteKey(),
      execution: 'execute',
      appearance: 'execute',
      callback: (token) => resolvePending(token),
      'error-callback': () => resolvePending(null),
      'timeout-callback': () => resolvePending(null),
    }) : null
    rearmWidget()
  } catch (e) {
    widgetId = null
  } finally {
    settleReady()
  }
}

export function initTurnstile() {
  if (initialized || typeof window === 'undefined' || !siteKey()) return
  initialized = true
  try {
    const container = document.createElement('div')
    container.id = CONTAINER_ID
    container.style.cssText = 'position:fixed;left:-9999px;top:0;width:300px;height:65px;opacity:0;pointer-events:none;'
    document.body.appendChild(container)

    const script = document.createElement('script')
    script.src = SCRIPT_URL
    script.async = true
    script.defer = true
    script.onload = renderWidget
    script.onerror = settleReady
    document.head.appendChild(script)
  } catch (e) {
    settleReady()
  }
}

export async function getCaptchaToken(action) {
  if (!siteKey() || typeof window === 'undefined') return null

  // The widget renders async after app start. For the required game actions,
  // wait for it rather than firing a gated call with no token just because we
  // got there first. Observe-only actions (auth) don't wait — they never block.
  if (action === 'game_start' || action === 'game_end') {
    await Promise.race([ready, new Promise((r) => setTimeout(r, READY_TIMEOUT_MS))])
  }

  if (!widgetId || !window.turnstile) return null

  return new Promise((resolve) => {
    let timer = null
    const settle = (token) => {
      if (timer === null) return
      clearTimeout(timer)
      timer = null
      if (pending === settle) pending = null
      resolve(token)
      rearmWidget()
    }
    pending = settle
    timer = setTimeout(() => settle(null), EXECUTE_TIMEOUT_MS)
    try {
      window.turnstile.execute('#' + CONTAINER_ID, { action })
    } catch (e) {
      settle(null)
    }
  }).catch(() => null)
}
